/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Cloud API Specification
 * OpenAPI spec version: 0.0.7
 */

export type AwsCollectorCreateCreateUpdateRequestService =
  (typeof AwsCollectorCreateCreateUpdateRequestService)[keyof typeof AwsCollectorCreateCreateUpdateRequestService];

export const AwsCollectorCreateCreateUpdateRequestService = {
  AURORA: 'AURORA',
  COST_EXPLORER: 'COST_EXPLORER',
  DMS_REPLINSTANCE: 'DMS_REPLINSTANCE',
  DMS_TASK: 'DMS_TASK',
  DOCUMENTDB: 'DOCUMENTDB',
  DYNAMODB: 'DYNAMODB',
  EC2: 'EC2',
  ECS_CLUSTER: 'ECS_CLUSTER',
  ECS_SERVICE: 'ECS_SERVICE',
  ELASTICACHE_CLUSTER: 'ELASTICACHE_CLUSTER',
  ELASTICACHE_NODE: 'ELASTICACHE_NODE',
  ELASTICACHE_SERVERLESS: 'ELASTICACHE_SERVERLESS',
  ELASTICACHE_SHARD: 'ELASTICACHE_SHARD',
  LAMBDA: 'LAMBDA',
  LIGHTSAIL_DATABASE: 'LIGHTSAIL_DATABASE',
  LIGHTSAIL_INSTANCE: 'LIGHTSAIL_INSTANCE',
  RDS: 'RDS',
  REDSHIFT: 'REDSHIFT',
  S3: 'S3',
  VPC: 'VPC',
} as const;
